module.exports = __webpack_public_path__ + "static/media/cacapalavras.524527b2.mp4";